import { useId } from 'react';

export function PageHeader({ title, description, children }) {
  const titleId = useId();

  return (
    <section aria-labelledby={titleId} className="pad-grid border-b border-grid">
      <div className="section-container py-16 sm:py-20 lg:py-24">
        <h1
          id={titleId}
          className="max-w-[20ch] text-4xl font-extrabold leading-[1.05] tracking-tight text-balance text-graphite sm:text-5xl"
        >
          {title}
        </h1>
        <p className="mt-5 max-w-[60ch] text-lg leading-relaxed text-steel sm:text-xl">{description}</p>
        {children ? <div className="mt-8 flex flex-wrap items-center gap-4">{children}</div> : null}
      </div>
    </section>
  );
}